// EST time
export const IQC_REGISTRATION_OPEN_DATE = new Date('2026-03-17T00:00:00.000-0400');
